import EnvironmentConfig from "@/EnvironmentConfig";

export function getAzureAuthority() {
  // Check if the environment variable for the authority to use
  const mfaEnabled = EnvironmentConfig.Azure.MfaEnabled;
  if (mfaEnabled === "true") {
    return EnvironmentConfig.Azure.AuthorityMfa;
  } else {
    return EnvironmentConfig.Azure.Authority;
  }
}
